import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function UrgencyBar() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  return <div className="sticky top-0 z-50 w-full bg-terracotta text-cream" data-id="element-135" data-mp="2p4sjqn1vcqw4">
      
    </div>;
}